module.exports = __webpack_public_path__ + "5025e527cdff2a11cbc380b497da6c9a.png";